export {default as RemoovIcon} from './remoovIcon.svg';
export {default as ThumbtackIcon} from './thumbtackIcon.svg';
export {default as PricePredictionIcon} from './pricePredictionIcon.svg';
export {default as GiftCardIcon} from './giftCardIcon.svg';
